import httpClient from "../axiosBase/axiosHandler";

export const getPlatformCreditInfo = () => {
  return httpClient.get("/termii/credit-account-info/");
};

export const getPlatformCreditTransactions = (
  queries = "",
  queryParams = {},
) => {
  return httpClient.get(`/termii/credit-transaction-history/${queries}`, {
    params: { ...queryParams },
  });
};

export const topPlatformCredit = (data) => {
  return httpClient.post("/termii/initiate-credit-top-up/", data);
};

export const createSenderId = (data) => {
  return httpClient.post("/termii/create-sender-id/", data);
};

export const getSenderList = () => {
  return httpClient.get("/termii/list-sender-ids/");
};
